if (!window.mfEditorialNavReady) {
  window.mfEditorialNavReady = true;
  document.addEventListener('click', event => {
    document.querySelectorAll('.mf-desktop-styles[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mf-desktop-styles[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const menu = event.target.closest?.('.mf-desktop-styles');
    if (menu) menu.open = true;
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse') return;
    const menu = event.target.closest?.('.mf-desktop-styles');
    if (menu && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
  });
}
